// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__10jJG","header":"styles_header__NugwH","title":"styles_title__1sAjS","tips":"styles_tips__3axqO"};